module.exports = __webpack_public_path__ + "img/text_icon.48c63c84.svg";